import React, { forwardRef } from 'react';

import { IconChevronDownSmall16, IconChevronUpSmall16 } from '../../../../Icons';
import { useCollapse } from '../../../../../utils';
import * as s from './RulesSwitch.css';

/**
 * Компонент переключателя правил
 */
export const RulesSwitch = forwardRef((_: unknown, ref: React.RefObject<HTMLDivElement | null>) => {
  const [toggleOptions, isOptionsShown] = useCollapse(ref, { isDefaultOpened: true });

  return (
    <div className={s['wrapper']} onClick={() => toggleOptions()}>
      {!isOptionsShown && (
        <>
          Правила расчета
          <IconChevronDownSmall16 />
        </>
      )}
      {isOptionsShown && (
        <>
          Свернуть
          <IconChevronUpSmall16 />
        </>
      )}
    </div>
  );
});

RulesSwitch.displayName = 'RulesSwitch';
